import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import InputLineGroup from "~/components/RegisterForm/InputLineGroup";
import api from "~/services/api";
import NewDatepicker from "~/pages/Financial/Outbounds/Payees/ModalFilters/NewDatepicker";

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export default function ConfigDate() {
  const [cutoffDate, setCutoffDate] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function loadSettings() {
      try {
        const { data } = await api.get("/surveyenrollment-settings");
        setCutoffDate(data?.cutoff_date || "");
      } catch (err) {
        console.log("Error fetching survey enrollment settings:", err);
      } finally {
        setLoaded(true);
      }
    }
    loadSettings();
  }, []);

  async function handleSave() {
    if (cutoffDate && !ISO_DATE.test(cutoffDate)) {
      toast("Please select a valid date.", { type: "error", autoClose: 3000 });
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put("/surveyenrollment-settings", {
        cutoff_date: cutoffDate || null,
      });
      setCutoffDate(data?.cutoff_date || "");
      toast("Saved!", { autoClose: 1000 });
    } catch (err) {
      toast(err?.response?.data?.error || "Save failed.", {
        type: "error",
        autoClose: 3000,
      });
    } finally {
      setSaving(false);
    }
  }

  return (
    <InputLineGroup title="Config Date" activeMenu={true}>
      <div className="flex flex-col gap-6 py-2">
        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-bold">Config Date</h2>
        </div>
        <div className="flex flex-col gap-3 border rounded-lg p-4 max-w-md">
          <p className="text-sm font-semibold">Enrollment Survey Date</p>
          <p className="text-xs text-gray-500">
            The enrollment survey only becomes available on, and after, this
            date. Leave it empty to keep the survey hidden.
          </p>
          <div className="flex flex-col justify-center items-start grow">
            <div className="px-2 text-xs flex flex-row justify-between items-center">
              Cutoff Date
            </div>
            <div className="w-full border border-gray-300 rounded-xs px-2 py-1 text-sm">
              <NewDatepicker
                value={cutoffDate}
                onChange={(value) => setCutoffDate(value || "")}
                className="w-full"
                placeholder="MM/DD/YYYY"
                disabled={!loaded}
              />
            </div>
          </div>
          <button
            type="button"
            disabled={saving || !loaded}
            onClick={handleSave}
            className="mt-1 text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md p-4 h-8 flex flex-row items-center justify-center text-xs gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </InputLineGroup>
  );
}
